<template>
  <vjs-modal :name="name" :title="title"
             width="400"
             v-bind="$options.propsData">
    <div class="form-group">
      <label for="role-name">New Role name:</label>
      <input v-model="role_name" type="text"
             name="role-name"
             class="form-control">
    </div>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="() => close(true)">
        Save Role
      </b-button>
      <b-button variant="ss" @click="() => close(false)">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `save-as-role`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: `save-as-role`,
    },
    title: {
      type: String,
      required: false,
      default: `Save as Role`,
    },
  },
  data: () => ({
    role_name: null,
  }),
  methods: {
    close(confirm) {
      this.close_data.confirm = confirm;
      if (confirm && this.role_name) {
        this.close_data.role_name = this.role_name;
      }
      this.complete();
      this.role_name = null;
    },
  },
};
</script>
